type Dataset = Record<string, string>;

export const getDataAttributes = (props: any): Dataset => {
  return Object.entries(props).reduce((acc: Dataset, [key, val]) => {
    if (key.includes('data-')) {
      acc[key] = val as string;
    }
    return acc;
  }, {});
};

export const getQaDataAttributes = (
  isQaMode: boolean | undefined,
  fullNameCompType: string | undefined,
) =>
  isQaMode
    ? { 'data-comp': fullNameCompType, 'data-aid': fullNameCompType }
    : {};

export const isEmptyObject = (obj: any) =>
  !obj || (Object.keys(obj).length === 0 && obj.constructor === Object);

let lastGeneratedId: number | null = null;
let uniqueIdCounter = 0;

export function getUniqueId(prefix: string, prefixDelimiter: string) {
  prefix = prefix || '';
  prefixDelimiter = prefixDelimiter || '';
  const value = Date.now();
  if (value === lastGeneratedId) {
    uniqueIdCounter++;
  } else {
    lastGeneratedId = value;
    uniqueIdCounter = 0;
  }
  return (
    prefix +
    prefixDelimiter +
    Number(lastGeneratedId).toString(36) +
    (uniqueIdCounter ? uniqueIdCounter : '')
  );
}

// normalizeWixUri , uri may appear in wix://v1/[uri] format we need to remove the wix://v1/ prefix
// cms full image format https://dev.wix.com/docs/velo/velo-only-apis/$w/image/src
// builder.image format https://dev.wix.com/docs/fed-guild/articles/builder/runtime/props#example-6
const WIX_IMAGE_URL_PREFIX = 'wix:image://v1/';

export const normalizeWixUri = (uri: string): string => {
  const withoutHash = uri.replace(/#.*$/, '');

  if (withoutHash.startsWith(WIX_IMAGE_URL_PREFIX)) {
    return withoutHash.slice(WIX_IMAGE_URL_PREFIX.length).split('/')[0];
  }

  return withoutHash.replace(/^wix:\/\/v1\//, '').replace(/\/.*$/, '');
};

export const getExternalImageUrl = (
  uri?: string,
  url?: string,
): string | undefined => {
  if (uri && /^https?:\/\//i.test(uri)) {
    return uri;
  }

  if (!uri && url && /^https?:\/\//i.test(url)) {
    return url;
  }

  return undefined;
};
